import { Country } from '@dreryk/address-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { PostcodeInput } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveCommonFormsBean } from '../../common.types';

type PostcodeFieldProps = Pick<FormContextValues<MedicalLeaveCommonFormsBean>, 'register' | 'watch'>;

export const PostcodeField = (props: PostcodeFieldProps): JSX.Element => {
   const country: Country | null = props.watch('address.country');

   return (
      <PostcodeInput
         controller={props.register('address.postcode', { required: true })}
         label={commonTranslationKeys.postcode}
         countryIsoCode={country?.getIsoCode()}
         testId={'postcode'}
         className={'postcode'}
      />
   );
};
